// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__N_c2n","inputWrap":"styles_inputWrap__1vDxv","input":"styles_input__2jjs-"};